export const CREATE_BATCH_REQUEST = 'CREATE_BATCH_REQUEST';
export const CREATE_BATCH_SUCCESS = 'CREATE_BATCH_SUCCESS';
export const CREATE_BATCH_FAILURE = 'CREATE_BATCH_FAILURE';

export const FETCH_BATCHES_REQUEST = 'FETCH_BATCHES_REQUEST';
export const FETCH_BATCHES_SUCCESS = 'FETCH_BATCHES_SUCCESS';
export const FETCH_BATCHES_FAILURE = 'FETCH_BATCHES_FAILURE';

export const DELETE_BATCH_REQUEST = 'DELETE_BATCH_REQUEST';
export const DELETE_BATCH_SUCCESS = 'DELETE_BATCH_SUCCESS';
export const DELETE_BATCH_FAILURE = 'DELETE_BATCH_FAILURE';

export const UPDATE_BATCH_REQUEST = 'UPDATE_BATCH_REQUEST';
export const UPDATE_BATCH_SUCCESS = 'UPDATE_BATCH_SUCCESS';
export const UPDATE_BATCH_FAILURE = 'UPDATE_BATCH_FAILURE';

export const ASSIGN_BATCH_REQUEST = 'ASSIGN_BATCH_REQUEST';
export const ASSIGN_BATCH_SUCCESS = 'ASSIGN_BATCH_SUCCESS';
export const ASSIGN_BATCH_FAILURE = 'ASSIGN_BATCH_FAILURE';

export const createBatchRequest = (data,projectId) => ({ type: CREATE_BATCH_REQUEST, payload: {data,projectId} });
export const createBatchSuccess = (batch) => ({ type: CREATE_BATCH_SUCCESS, payload: batch });
export const createBatchFailure = (error) => ({ type: CREATE_BATCH_FAILURE, payload: error });

export const fetchBatchesRequest = (projectId, options = {}) => {
  const { page = 1, limit = 1, search = '' } = options;
  return {
    type: FETCH_BATCHES_REQUEST,
    payload: { projectId, page, limit, search },
    
  };
  
};
  
  export const fetchBatchesSuccess = (batches) => ({
    type: FETCH_BATCHES_SUCCESS,
    payload: batches,
  });
  
  export const fetchBatchesFailure = (error) => ({
    type: FETCH_BATCHES_FAILURE,
    payload: error,
  });
  

export const deleteBatchRequest = (projectId,id) => ({ type: DELETE_BATCH_REQUEST, payload: {id,projectId} });
export const deleteBatchSuccess = (id) => ({ type: DELETE_BATCH_SUCCESS, payload: id });
export const deleteBatchFailure = (error) => ({ type: DELETE_BATCH_FAILURE, payload: error });

export const updateBatchRequest = (id, data,projectId) => ({ type: UPDATE_BATCH_REQUEST, payload: { id, data,projectId } });
export const updateBatchSuccess = (batch) => ({ type: UPDATE_BATCH_SUCCESS, payload: batch });
export const updateBatchFailure = (error) => ({ type: UPDATE_BATCH_FAILURE, payload: error });

export const assignBatchRequest = (id, teamIds) => ({ type: ASSIGN_BATCH_REQUEST, payload: { id, teamIds } });
export const assignBatchSuccess = (batch) => ({ type: ASSIGN_BATCH_SUCCESS, payload: batch });
export const assignBatchFailure = (error) => ({ type: ASSIGN_BATCH_FAILURE, payload: error });
